export function setFavourites(state, payload) {
    state.favourites = payload;
}

export function setHome(state, payload) {
    state.favouriteHome = payload;
}

export function setWork(state, payload) {
    state.favouriteWork = payload;
}

export function setFavouritesLists(state, payload) {
    state.favouritesLists = payload;
}

export function setSavedFavouriteTypes(state, payload) {
    state.savedFavouriteTypes = payload;
}

export function addFavourite(state, payload) {
    state.favourites.push(payload);
}

export function addFavouritesList(state, payload) {
    state.favouritesLists.push(payload);
}

export function saveRoute(state, payload) {
    if(!state.savedRoutes) state.savedRoutes = []
    state.savedRoutes.push(payload)
}

export function editFavourite(state, payload) {
    const favIndex = state.favourites.findIndex(favourite => favourite.id === payload.id);
    state.favourites.splice(favIndex, 1, payload)
    if(payload.id === 'work') {
        state.favouriteWork = payload
    }
    if(payload.id === 'home') {
        state.favouriteHome = payload
    }
}

export function editFavouritesList(state, payload) {
    const favListIndex = state.favouritesLists.findIndex(favouriteList => favouriteList.id === payload.id);
    state.favouritesLists.splice(favListIndex, 1, payload);
}

export function editSavedRoute(state, payload) {
    const routeIndex = state.savedRoutes.findIndex(route => route.id === payload.id);
    state.savedRoutes.splice(routeIndex, 1, payload);
}

export function removeFavourite(state, id) {
    const favIndex = state.favourites.findIndex(favourite => favourite.id.includes(id));
    state.favourites.splice(favIndex, 1);
    // also remove favourite from lists
    if(state.favouritesLists && state.favouritesLists.length > 0) {
        state.favouritesLists.forEach(list => {
            const favIndex = list.favorites.findIndex(favourite => favourite.id.includes(id));
            list.favorites.splice(favIndex, 1);
        })
    }
}

export function removeFavouritesList(state, id) {
    const favListIndex = state.favouritesLists.findIndex(favouriteList => favouriteList.id === id);
    state.favouritesLists.splice(favListIndex, 1);
}

export function removeSavedRoute(state, id) {
    const routeIndex = state.savedRoutes.findIndex(route => route.id === id);
    state.savedRoutes.splice(routeIndex, 1);
}

export function setSavedRoutes(state, payload) {
    state.savedRoutes = payload;
}

export function setSavedRoutesListOpen(state, payload) {
    state.savedRoutesListOpen = payload;
}

export function setSavedRouteClicked(state, payload) {
    state.savedRouteClicked = payload;
}

export function setFavouritePickerOpen(state, payload) {
    state.favouritePickerOpen = payload;
}

export function setFavouritePickerFieldIndex(state, payload) {
    state.favouritePickerFieldIndex = payload
}

export function setOpenFavouriteOverlayAfterLogin(state, payload) {
    state.openFavouriteOverlayAfterLogin = payload
}

export function setRouteTrafficAlerts(state, payload) {
    state.routeTrafficAlerts = payload
}

export function setSearchInputType(state, payload) {
    state.searchInputType = payload
}

export function setSavedRouteInfo(state, payload) {
    state.savedRouteInfo = payload
}

export function setActiveRouteSaved(state, payload) {
    state.activeRouteSaved = payload
}

export function removeRouteTrafficAlert(state, id) {
    const alertIndex = state.routeTrafficAlerts.findIndex(alert => alert.gisId === id);
    state.routeTrafficAlerts.splice(alertIndex, 1);
}